import * as React from "react";
import * as ReactDOM from "react-dom";
import App from "./App";
import {initShowBtnStickyPrice} from "../../../../../components/bookingStickyPrice/bookingStickyPrice";
import {initElemCustomSelect} from "../../../../../elements/customSelect/customSelect";
import {IBookingEngineQueryParameter, setConfiguration} from "../services/configuration.service";
import {urlRefineParametersConfig} from "../../config/form";
import {getUrlHashVar} from "orxapi.tools.url";
import {isMobileDevice} from "../../layout/device";

export interface IBookingEngine {
    availabilities: IBookingCalendarAvails;
    cities: { [city: string]: string };
    search: IBookingCalendarSearch;
    product: IBookingProduct;
    userCode: string;
}

export interface IBookingCalendarAvails {
    [city: string]: IBookingCalendarDuration | IBookingCalendarCapacity;
}

export interface IBookingProduct {
    code: string;
    toCode: string;
    document: { mainImage: { url: string; } };
    tourOperator: { code: string; };
    basePriceAvailability: IBookingProductAvailability;
    location: boolean;
}

export interface IBookingProductAvailability {
    departureCity: { code: string; };
    nbNights: number;
    nbDays: number;
    departureDate: string;
}

export interface IBookingCalendarSearch {
    departureCity: IBookingCalendarSearchCity[];
}

export interface IBookingCalendarSearchCity {
    code: string;
    lowestPrice: number;
    durationStay: Array<{ code: string, lowestPriceByDuration: number }>;
}

export interface IBookingCalendarDuration {
    [duration: string]: IBookingCalendarMonthYear;
}

export interface IBookingCalendarCapacity {
    [capacity: string]: IBookingCalendarDuration;
}

export interface IBookingCalendarMonthYear {
    [monthYear: string]: IBookingCalendarDay;
}

export interface IBookingCalendarDay {
    [day: string]: IAvailability;
}

export interface IAvailability {
    day: number;
    departureCity: string;
    departureDate: Date;
    status: string;
    byHousing?: boolean;
    maxPax?: number;
    minPax?: number;
    dayNb: number;
    nightNb: number;
    comment?: string;
    price: number;
    regularPrice?: number;
    reductionRate?: number;
    availRefTo?: string;
    departureLabel?: string;
    departureValue?: string;
    returnLabel?: string;
    returnValue?: string;
    categories?: ICabin[];
}

export interface ICabin {
    byHousing: boolean;
    categoryCode: string;
    categoryLabel: string;
    departureCity: string;
    departureCityLabel: string;
    dispoStatus: string;
    maxPax: number;
    minPax: number;
    price: number;
    regularPrice: number;
    status: string;
}

/**
 * getQueryFromHashParameters
 */
function getQueryFromHashParameters(): IBookingEngineQueryParameter {
    let hash = window.location.hash;
    const hashArray = hash.match(/#([^#]+).*/);
    if (hashArray && hashArray.length > 0) { // get values from the first # if there is many
        hash = hashArray[1];
    }
    const departureCity = getUrlHashVar(hash)[urlRefineParametersConfig.departureCity];
    const minMan = getUrlHashVar(hash)[urlRefineParametersConfig.durationNight];
    const mmd = getUrlHashVar(hash)[urlRefineParametersConfig.durationDay];
    if (departureCity && departureCity !== "") {
        if (minMan && minMan.indexOf(",") !== -1 && mmd && minMan.indexOf(",") !== -1) {
            const durationValue = mmd.split(",")[0] + "-" + minMan.split(",")[0];
            const day = getUrlHashVar(hash)[urlRefineParametersConfig.day];
            const monthYear = getUrlHashVar(hash)[urlRefineParametersConfig.monthYear];
            if (day && monthYear && monthYear.indexOf("/") !== -1) {
                const date = day + "-" + monthYear.replace("/", "-");
                return {city: departureCity, duration: durationValue, departureDate: date};
            }
            return {city: departureCity, duration: durationValue};
        } else {
            return {city: departureCity};
        }
    }
    return {};
}

/**
 * initBookingEngineComponent
 */
export function initBookingEngineComponent() {
    const bookingEngine = document.querySelector("#cptBookingProduct");
    const url = "/ajax/bookingEngine/" + bookingEngine.getAttribute("data-product-id");
    const submitUrlDesktop = bookingEngine.getAttribute("data-submit-url");
    const submitUrlMobile = bookingEngine.getAttribute("data-submit-url-mobile");
    const submitUrl = isMobileDevice() ? submitUrlMobile : submitUrlDesktop;
    const queryParameters = getQueryFromHashParameters();
    setConfiguration({baseUrl: url, queryParameters, submitUrl});
    ReactDOM.render(<App/>, bookingEngine, () => {
        initElemCustomSelect();
        initShowBtnStickyPrice();
        initUserInfo();
    });

}

/**
 * init UserInfo
 * @param root
 * @param dataUrl
 * @param callback
 */
function initUserInfo() {
    const pathname = window.location.pathname;
    if (pathname && pathname.indexOf("/b2b") !== -1) {
        $.ajax(
            "/ajax/user/userInfo")
            .done((response: any) => {
                if (response && response.firstName !== "") {
                    $(".user-info .text").append(response.civility + " " + response.firstName + " " + response.lastName);
                    $(".user-info").show();
                    const form = $("#cptBookingProduct form");
                    $("<input>").attr({
                        type: "hidden",
                        value: response.civility,
                        name: "agent.civility"
                    }).appendTo(form);
                    $("<input>").attr({
                        type: "hidden",
                        value: response.lastName,
                        name: "agent.lastName"
                    }).appendTo(form);
                    $("<input>").attr({
                        type: "hidden",
                        value: response.firstName,
                        name: "agent.firstName"
                    }).appendTo(form);
                    $("<input>").attr({
                        type: "hidden",
                        value: response.mail,
                        name: "agent.email"
                    }).appendTo(form);
                    $("<input>").attr({
                        type: "hidden",
                        value: response.tel,
                        name: "client.tel1"
                    }).appendTo(form);
                    $("<input>").attr({
                        type: "hidden",
                        value: response.street,
                        name: "client.facturationStreet"
                    }).appendTo(form);
                    $("<input>").attr({
                        type: "hidden",
                        value: response.postalCode,
                        name: "client.facturationPostalCode"
                    }).appendTo(form);
                    $("<input>").attr({
                        type: "hidden",
                        value: response.city,
                        name: "client.facturationCity"
                    }).appendTo(form);
                } else {
                    $(".user-info").remove();
                }
            });
    }
}
